import React, { useEffect, useState } from 'react'
import { Card, Dropdown, Typography } from 'antd'
// import CustomButton from 'components/atoms/CustomButton'
import SearchInput from 'components/atoms/SearchInput'
import FilterButton from 'components/atoms/FilterButton'
import Table from 'components/atoms/Table'
import CompanyDetailHeader from 'components/organisms/admin/companies/CompanyDetailHeader'
import { useLocation, useNavigate } from 'react-router-dom'
import { showErrorMessage, showSuccessMessage } from 'utils/showMessage'
import ChangeGptKeyModal from 'components/organisms/admin/companies/ChangeGptKeyModal'
import CompanyDetailInfo from 'components/organisms/admin/companies/CompanyDetailInfo'
import AdminPagination from 'components/atoms/AdminPagination'
import { useMutation, useQuery } from 'react-query'
import {
  getCompanyById,
  getCompanyCardsById,
  getCountryList,
  getOrdersList,
  getUserList,
  onCancelSubscription,
  onReactivateSubscription,
  onRequestBill,
  onUpdateSubscription
} from 'api'
import NullComponent from 'components/molecules/NullComponent'
import FilterPairUserCompany from 'components/organisms/admin/companies/FilterPairUserCompany'
import { useSelector } from 'react-redux'
import moment from 'moment'
import CustomButton from 'components/atoms/CustomButton'
import AddUserModal from 'components/organisms/admin/users/AddUserModal'
import { useTranslation } from 'react-i18next'
import CompanySubscriptionInfo from 'components/organisms/admin/companies/CompanySubscriptionInfo'
import ChangePlanModal from 'components/organisms/admin/companies/ChangePlanModal'
import CompanyPaymentCards from 'components/organisms/admin/companies/CompanyPaymentCards'
import ChangePaymentCardModal from 'components/organisms/admin/companies/ChangePaymentCardModal'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import CancelSubscriptionCompanyModal from 'components/organisms/admin/companies/CancelSubscriptionCompanyModal'
import ReactivateSubscriptionCompanyModal from 'components/organisms/admin/companies/ReactivateSubscriptionCompanyModal'
import { formatDate, isExpired, isExpiringSoon } from 'lib/utils'
import { SUBSCRIPTION_STATUS } from 'constant'
import CancelPaymentCardCompanyModal from '../../../components/organisms/admin/companies/CancelPaymentCardCompanyModal'

const initialTableState = {
  total: 0,
  page: 1,
  limit: 9,
  search: '',
  sort: 'created_at'
}

const initialOrdersTableState = {
  total: 0,
  page: 1,
  limit: 9,
  search: '',
  sort: 'created_at'
}

const initialFilterState = {
  role: undefined,
  typeDate: undefined,
  startDate: undefined,
  endDate: undefined
}

const initialOrdersFilterState = {
  role: undefined,
  typeDate: undefined,
  startDate: undefined,
  endDate: undefined
}

const CompanyDetailPage = () => {
  const navigate = useNavigate()
  const { t, i18n } = useTranslation()
  const location = useLocation()
  const [tableState, setTableState] = useState(initialTableState)
  const [ordersTableState, setOrdersTableState] = useState(initialOrdersTableState)
  const [filter, setFilter] = useState({ show: false })
  const [ordersFilter, setOrdersFilter] = useState({ show: false })
  const [filterState, setFilterState] = useState(initialFilterState)
  const [ordersFilterState, setOrdersFilterState] = useState(initialOrdersFilterState)
  const [pairUserModal, setPairUserModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [showGptKeyModal, setShowGptKeyModal] = useState(false)
  const [isChangePlanModalVisible, setChangePlanModalVisible] = useState(false)
  const [isAddCardVisible, setAddCardVisible] = useState(false)


  const [companyId, setCompanyId] = useState(location?.state?.id)

  const [modalCancelSubscription, setModalCancelSubscription] = useState(false)
  const [modalReactivateSubscription, setModalReactivateSubscription] = useState(false)

  const token = useSelector((state) => state.admin.access_token)

  const detail = useQuery({
    queryKey: ['admin-company-detail', companyId],
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const res = await getCompanyById(token, companyId)
      return res
    },
    enabled: !!companyId
  })

  const { isLoading: isOrdersLoading, data: orders, refetch: refetchOrders } = useQuery({
    queryKey: [
      'subscription-payment-history',
      ordersTableState?.sort,
      ordersTableState?.search,
      companyId,
      detail?.data?.resData?.data?.id,
      ordersFilterState
    ],
    refetchOnWindowFocus: false,
    queryFn: async () => {
      let filter = {
        ...ordersTableState,
        company: { value: companyId }
      }
      const res = await getOrdersList(token, ordersTableState?.page, filter, ordersTableState, companyId)
      return res
    },
    onSuccess: (res) => {
      setOrdersTableState({
        ...ordersTableState,
        total: res?.resData?.meta?.total
      })
    }
  })

  const { data: cards, refetch: refetchCards } = useQuery({
    queryKey: ['payment-cards', companyId],
    refetchOnWindowFocus: false,
    queryFn: async () => {
      if (!companyId) return null
      return await getCompanyCardsById(token, companyId)
    },
    enabled: !!companyId
  })

  const default_card = cards?.resData?.data.length > 0 && cards?.resData?.data?.find(el => el?.is_default)





  const countries = useQuery({
    queryKey: ['countries-list'],
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const res = await getCountryList(token)
      return res
    }
  })

  const { isLoading, data, refetch } = useQuery({
    queryKey: [
      'admin-companies-user-list',
      tableState?.sort,
      tableState?.search,
      companyId,
      detail?.data?.resData?.data?.id,
      filterState
    ],
    refetchOnWindowFocus: false,
    queryFn: async () => {
      let filter = {
        ...filterState,
        company: { value: companyId }
      }
      const res = await getUserList(token, tableState?.page, filter, tableState)
      return res
    },
    onSuccess: (res) => {
      setTableState({
        ...tableState,
        total: res?.resData?.meta?.total
      })
    }
  })

  const requestBill = useMutation({
    mutationKey: 'request-bill',
    mutationFn: (id) => onRequestBill(token, companyId, id),
    onSuccess: async (res) => {
      showSuccessMessage('Richiesto con successo')

    },
    onError: (err) => {
      console.log(err)

      if (err?.response?.data?.errors[0]?.code === 400) {
        showErrorMessage(err?.response?.data?.errors[0]?.message)
      } else {
        showErrorMessage(t('error messages.Internal server error'))
      }

    }
  })

  const cancelSubscription = useMutation({
    mutationKey: 'cancel-subscription',
    mutationFn: () => onCancelSubscription(token, companyId),
    onSuccess: async (res) => {
      showSuccessMessage(t('success messages.Plan cancelled successfully'))
      detail?.refetch()
      setModalCancelSubscription(false)

    },
    onError: (err) => {

      showErrorMessage(t('error messages.Internal server error'))
    }
  })

  const reactivateSubscription = useMutation({
    mutationKey: 'reactivate-subscription',
    mutationFn: () => onReactivateSubscription(token, companyId),
    onSuccess: async (res) => {
      showSuccessMessage(t('success messages.Plan reactivated successfully'))
      detail?.refetch()
      setModalReactivateSubscription(false)
    },
    onError: (err) => {

      showErrorMessage(t('error messages.Internal server error'))
    }
  })

  const updateSubscription = useMutation({
    mutationKey: 'update-subscription',
    onMutate: () => {
      setLoading(true)
    },
    mutationFn: (values) => onUpdateSubscription(token, companyId, values),
    onSuccess: async (res) => {
      showSuccessMessage(t('success messages.Plan updated successfully'))
      setLoading(false)
      detail?.refetch()
      setChangePlanModalVisible(false)

    },
    onError: (err) => {
      setLoading(false)
      showErrorMessage(t('error messages.Internal server error'))
    }
  })

  function closeFilterModal() {
    setFilter((prev) => ({ ...prev, show: false }))
  }

  function openPairUserModal() {
    setPairUserModal(true)
  }

  function closePairUserModal() {
    setPairUserModal(false)
  }

  const handleNavigationBack = () => {
    return navigate(-1)
  }

  const handleEditProfile = () => {
    showSuccessMessage(t('success messages.Profile edited'))
  }

  const handleDeleteProfile = () => {
    showSuccessMessage(t('success messages.Request sent account'))
  }

  const handleRetrieveProfile = () => {
    showSuccessMessage(t('success messages.Profile retrieved'))
  }

  function handleSubmitFilter(data) {
    setFilterState(data)
  }

  function resetFilter() {
    setFilterState({ ...initialFilterState })
  }

  const columns = [
    {
      id: 'name',
      name: 'USER NAME',
      selector: (row) => row?.name,
      sortable: true
    },
    {
      id: 'email',
      name: 'EMAIL',
      selector: (row) => row?.email,
      sortable: true
    },
    {
      id: 'phone',
      name: t('TELEPHONE NUMBER'),
      selector: (row) => row?.phone ?? '-',
      sortable: true
    },
    {
      id: 'role',
      name: t('ROLE'),
      selector: (row) => row?.role?.role ?? '-',
      sortable: true
    },
    {
      id: 'created_at',
      name: t('DATE'),
      selector: (row) => moment(row?.created_at).format('DD/MM/YYYY'),
      sortable: true
    }
  ]

  const orders_columns = [
    {
      id: 'id',
      name: t('Pay.OrderId'),
      selector: (row) => row?.id,
      sortable: true
    },
    {
      id: 'created_at',
      name: t('DATE'),
      selector: (row) => moment(row?.created_at).format('DD/MM/YYYY'),
      sortable: true
    },
    {
      id: 'total',
      name: t('Plans.Total'),
      selector: (row) => `${row?.total}€` ?? '-',
      sortable: true
    },
    {
      id: 'action',
      name: '',
      sortable: false,
      cell: (row) => (

        <div>
          <Dropdown

            menu={{
              items: [
                {
                  label: (
                    <div onClick={() => {
                      handleDownloadReceipt(row)
                    }}>
                      <Typography.Text> {t('Pay.DownloadReceipt')}</Typography.Text>
                    </div>

                  ),
                  key: 'DownloadReceipt'
                },
                {
                  label: (
                    <div onClick={() => {
                      handleRequestInvoice(row)
                    }}>
                      <Typography.Text> {t('Pay.RequestInvoice')}</Typography.Text>
                    </div>
                  ),
                  key: 'RequestInvoice'
                }
              ]
            }}
            trigger={['click']}
            placement="top"
            arrow={{
              pointAtCenter: true
            }}>
            <div

              className="hover:cursor-pointer hover:bg-[#ededef] flex  pl-2 pr-1 py-1 rounded-md"
              onClick={(e) => e.preventDefault()}>

              <MoreHorizIcon className="self-end text-end" />
            </div>
          </Dropdown>

        </div>


      )
    }
  ]

  function handleNavUserDetails(data) {
    navigate(`/admin/users/${data?.id}`)
  }

  function handleDownloadReceipt(row) {
    window.open(row?.receipt_url, '_blank')
  }

  function handleRequestInvoice(row) {
    requestBill.mutate(row?.id)
  }

  useEffect(() => {
    if (location?.state !== null && location?.state?.id) {
      setCompanyId(location?.state?.id)
      localStorage.setItem('companyId', location?.state?.id)
    } else {
      setCompanyId(localStorage.getItem('companyId'))
    }
  }, [location])

  return (
    <div className="w-full overflow-y-auto pr-6">
      <CompanyDetailHeader
        goBackNav={handleNavigationBack}
        companyName={detail?.data?.resData?.data?.name ?? location?.state?.name}
        date={detail?.data?.resData?.data?.created_at ?? location?.state?.created_at}
        onDeleteProfile={handleDeleteProfile}
        onEditProfile={handleEditProfile}
        onRetrieveProfile={handleRetrieveProfile}
        data={detail?.data?.resData?.data ?? location?.state}
        countries={countries}
        refetch={detail?.refetch}
      />

      {/* users deactivated */}
      {detail?.data?.resData?.data?.suspended_user_count > 0 && (
        <Card
          className={`rounded-lg transition-colors cursor-pointer bg-[#282828]  border-none mt-2`}>
          <p>{detail?.data?.resData?.data?.suspended_user_count} {t('Plans.Users deactivated')}</p>
          <p className='text-white text-base font-normal'>

            {t('Plans.Users deactivated text', { usersCount: detail?.data?.resData?.data?.suspended_user_count })}
            {formatDate(detail?.data?.resData?.data?.subscription?.next_payment_date)}

          </p>
        </Card>
      )}

      {/* plan not active */}
      {(detail?.data?.resData?.data?.subscription?.status === SUBSCRIPTION_STATUS.CANCELED ||
        detail?.data?.resData?.data?.subscription?.status === SUBSCRIPTION_STATUS.NOT_PAYED
      ) && (
          <Card
            className={`rounded-lg transition-colors cursor-pointer bg-[#282828]  border-none mt-2`}>
            <p className='font-semibold text-xs text-[rgba(255, 255, 255, 0.48)]'>{t('Plans.Attention').toUpperCase()}</p>
            <p className='text-white text-base font-normal'>{t('Plans.Plan is not active')}</p>
          </Card>
        )}

      {/* reactivate plan */}
      {detail?.data?.resData?.data?.subscription?.status === SUBSCRIPTION_STATUS.CANCELED && (
        <Card
          className={`rounded-lg transition-colors cursor-pointer bg-[#282828]  border-none mt-2`}>
          <div className='flex items-center justify-between'>
            <div>
              <p className='font-semibold text-xs text-[rgba(255, 255, 255, 0.48)]'>{t('Plans.Attention').toUpperCase()}</p>
              <p className='text-white text-base font-normal'>{t('Plans.PlanWillEndOn')} {formatDate(detail?.data?.resData?.data?.subscription?.expired_at)} </p>
            </div>

            {detail?.data?.resData?.data?.is_active_flag && (
              <CustomButton buttonColor="success" onClick={() => {
                setModalReactivateSubscription(true)

              }}>
                <div className="flex">

                  {t('Plans.Reactivate')}
                </div>

              </CustomButton>
            )}

          </div>

        </Card>
      )}

      {/* card expired */}
      {isExpired(default_card?.expired_at).expired && (

        <Card
          className={`rounded-lg transition-colors cursor-pointer bg-[#282828]  border-none mt-2`}>
          <div className='grid grid-cols-3'>

            <p className='font-semibold text-lg text-white '>{t('Plans.Payment method expired')}</p>
            <p className='text-white text-base font-normal col-span-2'>
              {t('Plans.Payment method expired text')}
            </p>



          </div>

        </Card>
      )}


      {/* plan in expiring */}
      {isExpiringSoon(detail?.data?.resData?.data?.subscription?.next_payment_date) === 'IN_EXPIRATION' &&
        detail?.data?.resData?.data?.subscription?.status !== SUBSCRIPTION_STATUS.CANCELED &&
        (detail?.data?.resData?.data?.subscription.expired_at != null && detail?.data?.resData?.data?.subscription.next_payment_date != null) &&
        (

          <Card
            className={`rounded-lg transition-colors cursor-pointer bg-[#282828]  border-none mt-2`}>
            <div className='grid grid-cols-3'>

              <p className='font-semibold text-lg text-white '>{t('Plans.Subscription expiring')}</p>
              <p className='text-white text-base font-normal col-span-2'>
                {t('Plans.Subscription expiring text')}
              </p>



            </div>

          </Card>
        )}


      {/* plan is expired */}
      {isExpiringSoon(detail?.data?.resData?.data?.subscription?.next_payment_date) === 'IS_EXPIRED' &&
        detail?.data?.resData?.data?.subscription?.status !== SUBSCRIPTION_STATUS.CANCELED &&
        (detail?.data?.resData?.data?.subscription.expired_at != null && detail?.data?.resData?.data?.subscription.next_payment_date != null) &&
        (

          <Card
            className={`rounded-lg transition-colors cursor-pointer bg-[#282828]  border-none mt-2`}>
            <div className='grid grid-cols-3'>

              <p className='font-semibold text-lg text-white '>{t('Plans.Subscription expired')}</p>
              <p className='text-white text-base font-normal col-span-2'>
                {t('Plans.Subscription expired text')}
              </p>



            </div>

          </Card>
        )}

      <CompanyDetailInfo {...(detail?.data?.resData?.data ?? location?.state)} />
      <div className="w-full h-[0.2px] bg-[#363636] my-2 mb-6" />


      {detail?.data?.resData?.data?.subscription?.id > 0 && (
        <>
          <CompanySubscriptionInfo data={detail?.data?.resData?.data ?? location?.state}
            onChangePlan={() => setChangePlanModalVisible(true)}
          />
          <div className="w-full h-[0.2px] bg-[#363636] my-2" />
        </>
      )}


      <div className="flex items-center px-4 mt-8 mb-4">
        <Typography.Title className="text-h2 font-manrope !text-white">
          {t('Paired Users')} ({detail?.data?.resData?.data?.user_count ?? location?.state?.user_count})
        </Typography.Title>
        <div className="flex-1 flex gap-2 ml-4 justify-between">
          <div className="flex gap-2">
            <SearchInput
              onSearch={(event) => {
                setTableState((prevState) => {
                  return {
                    ...prevState,
                    search: event.target.value
                  }
                })
              }}
            />
            <FilterButton
              onClick={() => {
                setFilter({ show: true })
              }}
            />
          </div>
          {detail?.data?.resData?.data?.is_active_flag && (
            <CustomButton className="ml-2" onClick={openPairUserModal}
              disabled={detail?.data?.resData?.data?.user_count >= detail?.data?.resData?.data?.subscription?.seat_number}>
              {t('Add')}
            </CustomButton>
          )}

        </div>
      </div>
      {((isLoading && !data) || (data?.resData?.data?.length > 0 && !isLoading)) && (
        <>
          <Table
            defaultSortFieldId={'created_at'}
            defaultSortAsc={false}
            onChangePrevPage={() => {
              if (tableState?.page > 1)
                setTableState((prevState) => {
                  return {
                    ...prevState,
                    page: prevState?.page - 1
                  }
                })
            }}
            onChangeNextPage={() => {
              if ((tableState?.page + 1) * tableState?.limit <= data?.resData?.meta?.total)
                setTableState((prevState) => {
                  return {
                    ...prevState,
                    page: prevState?.page + 1
                  }
                })
            }}
            sortServer
            onSort={(column, sortDirection) => {
              setTableState((prevState) => ({
                ...prevState,
                sort: `${sortDirection === 'desc' ? '-' : ''}${column?.id}`,
                sort_order: sortDirection
              }))
            }}
            pending={isLoading}
            data={data?.resData?.data ?? []}
            columns={columns}
            currentPage={tableState?.page}
            totalPerPage={tableState?.limit}
            page={tableState?.page}
            pageSize={tableState?.limit}
            totalRows={data?.resData?.meta?.total}
            onRowClicked={handleNavUserDetails}
            hidePagination
          />
          {data && (
            <div className="flex w-full justify-end items-center pb-5 mt-2">
              <AdminPagination
                count={Math.ceil(data?.resData?.meta?.total / tableState?.limit)}
                page={tableState?.page}
                onChange={(_, page) => {
                  setTableState((prevState) => ({
                    ...prevState,
                    page: page
                  }))
                }}
                shape="rounded"
              />
            </div>
          )}
        </>
      )}

      {detail?.data?.resData?.data?.subscription?.id > 0 && (
        <CompanyPaymentCards data={cards?.resData?.data || []}
          onAddCard={() => setAddCardVisible(true)}
        />
      )}

      {detail?.data?.resData?.data?.subscription?.id > 0 && (
        <>
          <div className="flex items-center px-4 mt-8 mb-4">
            <Typography.Title className="text-h2 font-manrope !text-white">
              {t('Pay.OrdersHistory')} ({orders?.resData?.data?.length || 0})
            </Typography.Title>
            <div className="flex-1 flex gap-2 ml-4 justify-between">
              <div className="flex gap-2">
                {/* <SearchInput
              onSearch={(event) => {
                setOrdersTableState((prevState) => {
                  return {
                    ...prevState,
                    search: event.target.value
                  }
                })
              }}
            /> */}
                <FilterButton
                  onClick={() => {
                    setOrdersFilter({ show: true })
                  }}
                />
              </div>

            </div>
          </div>
          {((isOrdersLoading && !orders) || (orders?.resData?.data?.length > 0 && !isOrdersLoading)) && (
            <>
              <Table
                defaultSortFieldId={'created_at'}
                defaultSortAsc={false}
                onChangePrevPage={() => {
                  if (ordersTableState?.page > 1)
                    setOrdersTableState((prevState) => {
                      return {
                        ...prevState,
                        page: prevState?.page - 1
                      }
                    })
                }}
                onChangeNextPage={() => {
                  if ((ordersTableState?.page + 1) * ordersTableState?.limit <= orders?.resData?.meta?.total)
                    setOrdersTableState((prevState) => {
                      return {
                        ...prevState,
                        page: prevState?.page + 1
                      }
                    })
                }}
                sortServer
                onSort={(column, sortDirection) => {
                  setOrdersTableState((prevState) => ({
                    ...prevState,
                    sort: `${sortDirection === 'desc' ? '-' : ''}${column?.id}`,
                    sort_order: sortDirection
                  }))
                }}
                pending={isOrdersLoading}
                data={orders?.resData?.data ?? []}
                columns={orders_columns}
                currentPage={ordersTableState?.page}
                totalPerPage={ordersTableState?.limit}
                page={ordersTableState?.page}
                pageSize={ordersTableState?.limit}
                totalRows={orders?.resData?.meta?.total}
                //onRowClicked={handleNavUserDetails}
                hidePagination
              />
              {orders && (
                <div className="flex w-full justify-end items-center pb-5 mt-2">
                  <AdminPagination
                    count={Math.ceil(orders?.resData?.meta?.total / ordersTableState?.limit)}
                    page={ordersTableState?.page}
                    onChange={(_, page) => {
                      setOrdersTableState((prevState) => ({
                        ...prevState,
                        page: page
                      }))
                    }}
                    shape="rounded"
                  />
                </div>
              )}
            </>
          )}
        </>
      )}

      {data?.resData?.data?.length < 1 && !isLoading && (
        <div className="mx-4">
          <NullComponent
            title={'No user paired'}
          // description={'Pair users to it'}
          />
        </div>
      )}
      <FilterPairUserCompany
        show={filter.show}
        onClose={closeFilterModal}
        onSubmit={handleSubmitFilter}
        resetFilter={resetFilter}
        filterState={filterState}
      />
      <AddUserModal
        show={pairUserModal}
        company={{
          id: companyId,
          name: location?.state?.name
        }}
        onClose={closePairUserModal}
        refetchUserList={refetch}
      />
      <ChangeGptKeyModal
        open={showGptKeyModal}
        gptKey={location?.state?.gpt_key}
        onClose={() => {
          setShowGptKeyModal(false)
        }}
        onSubmit={() => {
          showSuccessMessage(t('success messages.Secret key edited'))
          setShowGptKeyModal(false)
        }}
        refetch={detail?.refetch}
        data={detail?.data?.resData?.data ?? location?.state}
      />


      {isChangePlanModalVisible && (
        <ChangePlanModal
          loading={loading}
          onClose={() => {
            setChangePlanModalVisible(false)
          }}
          show={isChangePlanModalVisible}
          currentPlan={detail?.data?.resData?.data?.subscription}
          token={token}
          companyId={companyId}

          onSubmit={(values) => {
            updateSubscription.mutate(values)
          }}
          onCancelPlan={() => {
            setModalCancelSubscription(true)
          }}
          onReactivatePlan={() => {
            setModalReactivateSubscription(true)
          }}
        />
      )}


      <CancelSubscriptionCompanyModal
        show={modalCancelSubscription}
        onClose={() => {
          setModalCancelSubscription(false)
        }}
        onCancelSubscription={() => {
          cancelSubscription.mutate()
        }}
      />

      <ReactivateSubscriptionCompanyModal
        show={modalReactivateSubscription}
        onClose={() => {
          setModalReactivateSubscription(false)
        }}
        onReactivateSubscription={() => {
          reactivateSubscription.mutate()
        }}
      />



      {isAddCardVisible && (
        <ChangePaymentCardModal
          onClose={() => {
            setAddCardVisible(false)
          }}
          show={isAddCardVisible}
          cards={cards?.resData?.data || []}
          companyId={companyId}
          onSubmit={() => {
            refetchCards()
          }} />
      )}



    </div>
  )
}

export default CompanyDetailPage
